import { jsx } from "react/jsx-runtime";
import { token } from "@/styled-system/tokens";
import { Box } from "@zillow/constellation-10";
import { useMemo } from "react";
import BarChart from "../PaymentDonutChart/BarChart/BarChart.esm.js";
import PropInterpolatorWrapper from "../PaymentDonutChart/Chart/common/PropInterpolator.esm.js";
import withDimensions from "../PaymentDonutChart/withDimensions.esm.js";
import { useLastValidRefinanceValues, useRefinanceColors, abbr } from "./RefinanceCalculator.utils.esm.js";
const YEAR_MONTHS = 12;
const CONSTELLATION_FONT_FAMILY = 'Inter, "Helvetica Neue", "Adjusted Arial", sans-serif';
const RefinanceBarGraphBase = ({
  containerWidth
}) => {
  const values = useLastValidRefinanceValues();
  const colors = useRefinanceColors();
  const dataPoints = useMemo(() => {
    const newDataPoints = [{
      label: "Costs",
      value: values.fields.fees,
      color: colors.costsColor
    }];
    const maybePlotDataPoint = ({
      yearsAtDataPoint
    }) => {
      const monthsAtDataPoint = yearsAtDataPoint * YEAR_MONTHS;
      if (monthsAtDataPoint === 0 || values.calculations.savingsSchedule.length < monthsAtDataPoint) {
        return;
      }
      newDataPoints.push({
        label: `${yearsAtDataPoint}yrs`,
        value: values.calculations.savingsSchedule[monthsAtDataPoint - 1].totalSavings,
        color: colors.lifetimeSavingsColor
      });
    };
    const totalYears = values.calculations.savingsSchedule.length / YEAR_MONTHS;
    maybePlotDataPoint({
      yearsAtDataPoint: 1
    });
    maybePlotDataPoint({
      yearsAtDataPoint: Math.round(totalYears / 3 * 2)
    });
    maybePlotDataPoint({
      yearsAtDataPoint: Math.floor(totalYears)
    });
    return newDataPoints.map((item) => ({
      ...item,
      value: item.value > 0 ? item.value : 0
    }));
  }, [values.calculations.savingsSchedule, values.fields.fees, colors.costsColor, colors.lifetimeSavingsColor]);
  const textStroke = token.var("colors.text.action.neutral.default");
  const axesColor = token.var("colors.bg.action.impact.bare.hover");
  return /* @__PURE__ */ jsx(Box, { css: {
    fontSize: "body",
    height: "150px"
  }, children: /* @__PURE__ */ jsx(BarChart, { legend: false, data: dataPoints, width: containerWidth, height: 150, tickTextStroke: textStroke, axesColor, xAxisFormatter: (x) => `$${abbr(x)}`, fontFamily: CONSTELLATION_FONT_FAMILY }) });
};
const DimensionedThemedRefinanceBarGraph = withDimensions(RefinanceBarGraphBase, {
  defaultHeight: 150,
  defaultWidth: 311
});
const RefinanceBarGraph = PropInterpolatorWrapper(DimensionedThemedRefinanceBarGraph);
export {
  RefinanceBarGraph as default
};
